import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import UserContext from "../context/UserContext";
import { useTheme } from "../context/ThemeContext";

const NavBar = () => {
  const { user, Logout } = useContext(UserContext);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  if (location.pathname.startsWith("/cliente/")) return null;

  const handleLogout = () => {
    Logout();
    closeMenu();
  };

  const themeButton = (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={theme === "dark" ? "Activar modo claro" : "Activar modo oscuro"}
      title={theme === "dark" ? "Modo claro" : "Modo oscuro"}
      className="inline-flex items-center gap-2 rounded-md border border-black/10 dark:border-white/10 px-3 py-1.5 text-sm  transition hover:bg-white/10"
    >
      <span aria-hidden="true">{theme === "dark" ? "☀" : "☾"}</span>
      <span>{theme === "dark" ? "Claro" : "Oscuro"}</span>
    </button>
  );

  return (
    <nav className="relative border-b border-black/10 dark:border-white/10 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="text-lg font-semibold tracking-tight " onClick={closeMenu}>
          Sistema de Fidelidad
        </Link>

        {user && (
          <>
            <button
              type="button"
              onClick={() => setIsMenuOpen((open) => !open)}
              aria-label="Abrir menú"
              className="inline-flex items-center rounded-md border border-black/10 dark:border-white/10 p-2  sm:hidden"
            >
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>

            <div className="hidden items-center gap-4 text-sm text-slate-700 dark:text-slate-300 sm:flex">

              <Link to="/customers" className="transition hover:text-white" onClick={closeMenu}>
                Clientes
              </Link>
              <button
                onClick={() => { toggleTheme(); setIsMenuOpen(false); }}
                className="rounded-md border border-black/10 dark:border-white/10 px-3 py-1.5 transition hover:bg-white/10"
              >
                {theme === "dark" ? "☀" : "☾"} <span className="text-sm normal-case">Cambiar tema</span>
              </button>
              <button
                onClick={handleLogout}
                className="rounded-md border border-black/10 dark:border-white/10 px-3 py-1.5 transition hover:bg-white/10"
              >
                Cerrar Sesión
              </button>
            </div>
          </>
        )}
      </div>

      {user && isMenuOpen && (
        <div className="border-t border-black/10 dark:border-white/10 bg-slate-100 dark:bg-slate-900/95 shadow-lg shadow-black/20 sm:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-3 sm:px-6">
            <Link to="/customers" className="rounded-lg px-2 py-2 text-sm transition hover:bg-white/10" onClick={closeMenu}>
              Clientes
            </Link>
            {themeButton}
            <button
              onClick={handleLogout}
              className="rounded-lg border border-black/10 dark:border-white/10 px-2 py-2 text-left text-sm  transition hover:bg-white/10"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;
